var _rect, _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FE815F",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 27.9411 8.05888 36 18 36C27.9411 36 36 27.9411 36 18C36 8.05888 27.9411 0 18 0C8.05888 0 0 8.05888 0 18Z",
    fill: "#FE815F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12905_15913)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6851 28.7998H12.3286C11.455 28.7998 10.7998 28.0498 10.7998 27.0498V8.0498C10.7998 7.0498 11.455 6.2998 12.3286 6.2998H23.6851C24.5587 6.2998 25.2139 7.0498 25.2139 8.0498V27.0498C25.2139 28.0498 24.5587 28.7998 23.6851 28.7998ZM22.1437 23.3512H13.8282C13.1717 23.3512 12.734 22.7913 12.734 21.9515V9.63375C12.734 8.79391 13.1717 8.23401 13.8282 8.23401H22.3625C23.019 8.23401 23.4567 8.79391 23.4567 9.63375V21.9515C23.2378 22.7913 22.8002 23.3512 22.1437 23.3512ZM17.0748 26.833C16.8276 26.5857 16.6887 26.2504 16.6887 25.9007C16.6887 25.5511 16.8276 25.2158 17.0748 24.9685C17.322 24.7213 17.6574 24.5824 18.007 24.5824C18.3567 24.5824 18.692 24.7213 18.9392 24.9685C19.1865 25.2158 19.3254 25.5511 19.3254 25.9007C19.3254 26.2504 19.1865 26.5857 18.9392 26.833C18.692 27.0802 18.3567 27.2191 18.007 27.2191C17.6574 27.2191 17.322 27.0802 17.0748 26.833Z",
    fill: "#FAFBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12905_15913",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 6,
    width: 16,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6861 28.7969H12.3295C11.456 28.7969 10.8008 28.0469 10.8008 27.0469V8.04688C10.8008 7.04688 11.456 6.29688 12.3295 6.29688H23.6861C24.5597 6.29688 25.2148 7.04688 25.2148 8.04688V27.0469C25.2148 28.0469 24.5597 28.7969 23.6861 28.7969ZM22.1447 23.3483H13.8291C13.1726 23.3483 12.735 22.7884 12.735 21.9485V9.63082C12.735 8.79098 13.1726 8.23108 13.8291 8.23108H22.3635C23.02 8.23108 23.4576 8.79098 23.4576 9.63082V21.9485C23.2388 22.7884 22.8012 23.3483 22.1447 23.3483ZM17.0758 26.83C16.8285 26.5828 16.6896 26.2475 16.6896 25.8978C16.6896 25.5482 16.8285 25.2128 17.0758 24.9656C17.323 24.7183 17.6583 24.5794 18.008 24.5794C18.3577 24.5794 18.693 24.7183 18.9402 24.9656C19.1875 25.2128 19.3264 25.5482 19.3264 25.8978C19.3264 26.2475 19.1875 26.5828 18.9402 26.83C18.693 27.0773 18.3577 27.2162 18.008 27.2162C17.6583 27.2162 17.323 27.0773 17.0758 26.83Z",
    fill: "#FAFBFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12905_15913",
    x: 6.7998,
    y: 4.2998,
    width: 22.4141,
    height: 30.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.86658 0 0 0 0 0.24618 0 0 0 0 0.0774305 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12905_15913"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12905_15913",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.859686ef5b74af47cbbf3869a1b8f657.svg";
export { ForwardRef as ReactComponent };